export default __webpack_public_path__ + "static/media/profileImage.d375c75b.png";